module.exports = __webpack_public_path__ + "imgs/arrow-down-black.494593778df9bd6425b675a33728259c.svg";